import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getCalendarEntity } from '@constants/config';
import EventIcon from '@icons/event-icon';
import { Icon, IconButton } from '@mui';
import DefaultDate from '@shared/formatted-date-helper';
import { canEditEntities } from '@utils/permission-utils';
import './event-details-popup.scss';

const EventDetailsPopup = ({ selectedEvent, windowClose }) => {
  const editEvents = canEditEntities(null, getCalendarEntity());
  return (
    <div styleName={`popup-container ${editEvents ? '' : 'popup-container-read-only-events'}`}>
      {/* Positioned like the close button in the app's shared dialog
          (shared/dialogs/dialog.js), rather than trailing after the title text below. */}
      <IconButton
        aria-label="Close"
        onClick={windowClose}
        style={{ margin: 0, padding: 0, position: 'absolute', top: 0, right: 0 }}
      >
        <Icon role="img">close</Icon>
      </IconButton>
      <div styleName="row">
        <EventIcon />
        <span styleName="title">{selectedEvent.title}</span>
      </div>
      <div styleName="row">
        <div styleName="data-label">When</div>
        <DefaultDate value={selectedEvent.start} />
        <span> - </span>
        <DefaultDate value={selectedEvent.end} />
      </div>
      <div styleName="row">
        <div styleName="data-label">Where</div>
        <div>{selectedEvent.address}</div>
        <div styleName="view-on-map-link">
          <Link to={`/map?${getCalendarEntity()}=${selectedEvent.id}`}>
            <div styleName="view-on-map-label">
              <Icon onClick={windowClose} color="#0273CE" style={{ fontSize: '1rem' }} role="img" aria-hidden="true">
                place
              </Icon>
              View on map
            </div>
          </Link>
        </div>
      </div>
      <div styleName="row">
        <div styleName="data-label">Created by</div><div>{selectedEvent.agency}</div>
      </div>
      <div styleName="row">
        <div styleName="data-label">Event type</div><div>{selectedEvent.typeName}</div>
      </div>
    </div>
  );
};

EventDetailsPopup.propTypes = {
  selectedEvent: PropTypes.object,
  windowClose: PropTypes.func
};

export default EventDetailsPopup;
